import styled from '@emotion/styled';
import { Row } from '../../../styles';

const DetailedFiltersWrapper = styled(Row)`
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
    flex-wrap: wrap;
    border-radius: ${({ theme }) => theme.spacing(0.5)};
`;

export { DetailedFiltersWrapper };
